import { PROJECT_NAME } from "@/config/project-details";
import { cn } from "@/utils/helpers";
import Image from "next/image";
import Link from "next/link";

type ProjectLogoProps = {
  variant?: "full" | "icon";
  className?: string;
  iconStyles?: string;
};

export default function ProjectLogo({ variant = "icon", className, iconStyles }: ProjectLogoProps) {
  return (
    <Link href="/" className={cn("flex items-center gap-2", className)}>
      <div className={cn("relative size-8", iconStyles)}>
        <Image src="/images/logo/outline/logo-v1.svg" alt={`Logo image of ${PROJECT_NAME}`} fill unoptimized />
      </div>
      {variant === "full" && (
        <p className="self-stretch whitespace-nowrap pt-0.5 text-2xl font-bold tracking-tighter md:text-xl md:font-semibold">
          {PROJECT_NAME}
        </p>
      )}
    </Link>
  );
}

{
  /* <p>✨</p>
  {variant === "full" && <p className="font-clashDisplay font-bold uppercase">Luva</p>}
<span className="sr-only">{PROJECT_NAME}</span> */
}
